/**
 * Appointment enums for the new calendar module.
 * Values mirror the backend (AppointmentMode / AppointmentType / AppointmentStatus).
 * Labels are English defaults — always rendered through msg() for i18n.
 */

export const APPOINTMENT_MODES = [
    {value: 'PHYSICAL', label: 'Physical', icon: 'MapPinIcon'},
    {value: 'PHONE', label: 'Phone', icon: 'PhoneIcon'},
    {value: 'VIDEO', label: 'Video', icon: 'VideoIcon'},
];

// duration = default minutes (kept in sync with backend AppointmentType)
export const APPOINTMENT_TYPES = [
    {value: 'FIRST_CONSULTATION', label: 'First consultation', duration: 30, color: '#7367f0'},
    {value: 'ONBOARDING', label: 'Onboarding', duration: 60, color: '#00cfe8'},
    {value: 'SUPPORT', label: 'Support', duration: 10, color: '#ff9f43'},
    {value: 'FOLLOW_UP', label: 'Follow-up', duration: 30, color: '#28c76f'},
    {value: 'VIEWING', label: 'Viewing', duration: 45, color: '#e83e8c'},
    {value: 'MEETING', label: 'Meeting', duration: 60, color: '#4b4b9b'},
    {value: 'OTHER', label: 'Other', duration: 30, color: '#82868b'},
];

export const APPOINTMENT_STATUSES = [
    {value: 'REQUESTED', label: 'Requested', variant: 'light-warning'},
    {value: 'SCHEDULED', label: 'Scheduled', variant: 'light-primary'},
    {value: 'COMPLETED', label: 'Completed', variant: 'light-success'},
    {value: 'CANCELLED', label: 'Cancelled', variant: 'light-secondary'},
    {value: 'NO_SHOW', label: 'No show', variant: 'light-danger'},
    {value: 'DECLINED', label: 'Declined', variant: 'light-danger'},
];

export function appointmentType(value) {
    return APPOINTMENT_TYPES.find((t) => t.value === value) || APPOINTMENT_TYPES[APPOINTMENT_TYPES.length - 1];
}

export function appointmentMode(value) {
    return APPOINTMENT_MODES.find((m) => m.value === value) || APPOINTMENT_MODES[0];
}

export function appointmentStatus(value) {
    return APPOINTMENT_STATUSES.find((s) => s.value === value) || APPOINTMENT_STATUSES[0];
}

export function typeColor(value) {
    return appointmentType(value).color;
}
